import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#71717a] dark:placeholder:text-[#a1a1aa] outline-none focus:outline-none focus-visible:outline-none focus:ring-2 focus:ring-[#38BDF8]/30 focus:border-[#38BDF8] focus-visible:ring-2 focus-visible:ring-[#38BDF8]/30 focus-visible:border-[#38BDF8] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
